<template>
    <div>
        <h5 class="mb-1">Mantenimientos - Tareas</h5>
        <b-table
            :items="documentsStateData"
            :fields="documentsColumns"
            responsive
            sticky-header="500px"
            striped
            primary-key="id"
            show-empty
            editable
            empty-text="No hay registros"
            @row-clicked="handleRowClick"
        >
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>

            <template #cell(select_maintenance)="{ item }">
                <template>
                    <b-form-group class="form-check form-check-inline d-flex justify-content-center">
                        <b-form-radio v-model="item.select_maintenance" :checked="item.id == document_maintenance_active" name="select-maintenance" @change="setActiveMaintenance(item)" />
                    </b-form-group>
                </template>
            </template>

            <template #cell(expected_date)="{ item }">
                <template v-if="isRowEditable(item)">
                    <flat-pickr
                        v-model="item.expected_date"
                        class="form-control width-115"
                        name="expected_date"
                        autocomplete="off"
                        :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                    />
                </template>
                <template v-else>
                     <span class="text-nowrap">
                           {{ item.expected_date }}
                     </span>
                </template>
            </template>

            <template #cell(report_review_date)="{ item }">
                <template v-if="isRowEditable(item)">
                    <flat-pickr
                        v-model="item.report_review_date"
                        class="form-control width-115"
                        name="expected_date"
                        autocomplete="off"
                        :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                    />
                </template>
                <template v-else>
                       <span class="text-nowrap">
                             {{ item.report_review_date }}
                     </span>
                </template>
            </template>

            <template #cell(detection_timestamp)="{ item }">
                <template v-if="isRowEditable(item)">
                    <flat-pickr
                        v-model="item.detection_timestamp"
                        class="form-control width-115"
                        name="expected_date"
                        autocomplete="off"
                        :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                    />
                </template>
                <template v-else>
                       <span class="text-nowrap">
                             {{ item.detection_timestamp }}
                     </span>
                </template>
            </template>

            <template #cell(resolution_timestamp)="{ item }">
                <template v-if="isRowEditable(item)">
                    <flat-pickr
                        v-model="item.resolution_timestamp"
                        class="form-control width-115"
                        name="expected_date"
                        autocomplete="off"
                        :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y' }"
                    />
                </template>
                <template v-else>
                       <span class="text-nowrap">
                             {{ item.resolution_timestamp }}
                     </span>
                </template>
            </template>

            <template #cell(urgency)="{ item }">
              <template v-if="isRowEditable(item)">
                <b-form-group class="form-check form-check-inline">
                  <b-form-checkbox v-model="item.urgency" :value="1"/>
                </b-form-group>
              </template>
              <template v-else>
                <b-form-checkbox v-model="item.urgency" disabled="disabled" :value="1"/>
              </template>
            </template>

            <template #cell(effective_date)="{ item }">
                <div :style="{ backgroundColor: item.inspection ? 'rgba(0, 128, 0, 0.2)' : (item.has_documents ? 'rgba(0, 167, 225, 0.2)' : '') }">
                    <template v-if="isRowEditable(item)">
                        <flat-pickr
                            v-model="item.effective_date"
                            class="form-control width-115"
                            name="effective_date"
                            autocomplete="off"
                            :config="{ dateFormat: 'd-m-Y', locale: SpanishLocale, allowInput: true, altInput: true, altFormat: 'd-m-Y'}"
                        />
                    </template>
                    <template v-else>
                        <span class="text-nowrap">
                             {{ item.effective_date }}
                     </span>
                    </template>
                </div>
            </template>

            <template #cell(periodicity)="{ item }">
                <template>
                    {{
                        maintenancePeriods.find(element => element.value == item.periodicity) ? maintenancePeriods.find(element => element.value == item.periodicity).name : ''
                    }}
                </template>
            </template>

          <template #cell(maintenance_arrive_timestamp)="{ item }">
            <template v-if="isRowEditable(item)">
              <b-form-input v-model="item.maintenance_arrive_timestamp" autocomplete="off" :style="{ width: '140px' }"/>
            </template>
            <template v-else>
              {{ item.maintenance_arrive_timestamp }}
            </template>
          </template>

            <template #cell(operator_nif_1)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.operator_nif_1" autocomplete="off" :style="{ width: '140px' }"/>
                </template>
                <template v-else>
                    {{ item.operator_nif_1 }}
                </template>
            </template>

            <template #cell(operator_nif_2)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-input v-model="item.operator_nif_2" autocomplete="off" :style="{ width: '140px' }"/>
                </template>
                <template v-else>
                    {{ item.operator_nif_2 }}
                </template>
            </template>

            <template #cell(report_review)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-group class="form-check form-check-inline">
                        <b-form-checkbox v-model="item.report_review" :value="1"/>
                    </b-form-group>
                </template>
                <template v-else>
                    <b-form-checkbox v-model="item.report_review" disabled="disabled" :value="1"/>
                </template>
            </template>

            <template #cell(observations)="{ item }">
                <template v-if="isRowEditable(item)">
                    <b-form-textarea v-model="item.observations" autocomplete="off"/>
                </template>
                <template v-else>
                    {{ item.observations }}
                </template>
            </template>

            <template #cell(provider_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.provider_id"
                        class="pt-0 width-300" label="provider" name="provider"
                        :reduce="(option) => option.id"
                        :options="providers"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{
                        providers.find(element => element.id == item.provider_id) ? providers.find(element => element.id == item.provider_id).provider : ''
                    }}
                </template>
            </template>


            <template #cell(incidences)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.incidences"
                        class="pt-0 width-300" label="description" name="description"
                        :reduce="(option) => option.id"
                        :options="incidencesTypes"
                        append-to-body
                        multiple
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    <b-badge v-for="(item, index) in item.incidences" :key="index">
                        {{ item.description }}
                    </b-badge>
                </template>
            </template>

            <template #cell(document_type_id)="{ item }">
                <template v-if="isRowEditable(item)">
                    <v-select
                        v-model="item.document_type_id"
                        class="pt-0 width-300" label="type" name="type"
                        :reduce="(option) => option.id"
                        :options="documentsTypes"
                        append-to-body
                        :calculate-position="withPopper"
                    />
                </template>
                <template v-else>
                    {{
                        documentsTypes.find(element => element.id == item.document_type_id) ? documentsTypes.find(element => element.id == item.document_type_id).type : ''
                    }}
                </template>
            </template>
            <template #cell(options)="data">
                <div class="d-flex align-items-center" @click.stop>
                    <feather-icon
                        v-if="createPermission"
                        :id="`record-row-${data.item.id}-edit-icon`"
                        :icon="getButtonIcon(data.item)"
                        class="cursor-pointer mr-1"
                        :class="getButtonVariant(data.item)"
                        size="16"
                        @click="editRow(data.item)"
                    />

                    <feather-icon
                        v-if="data.item.id"
                        :id="`record-row-${data.item.id}-see-icon`"
                        icon="SearchIcon"
                        size="16"
                        variant="warning"
                        class="cursor-pointer mr-1 text-blue"
                        @click="seeDocumentsList(data.item.id)"
                    />
                    <feather-icon
                        v-if="deletePermission"
                        :id="`record-row-${data.item.id}-delete-icon`"
                        icon="TrashIcon"
                        size="16"
                        class="cursor-pointer text-red"
                        @click="deleteRecord(data.item.id, data.index )"
                    />

                </div>
            </template>

        </b-table>

        <b-modal v-model="showModal" hide-footer title="Documentos" size="lg">
            <b-table
                ref="refUserListTable"
                :items="documentsRoute"
                responsive
                :fields="columnsDocuments"
                primary-key="id"
                show-empty
                sticky-header
                editable
                striped
                empty-text="No hay registros"
                class="table-bordered "
                :key-field="'index'"
            >
                <template #cell(options)="data">
                    <div class="d-flex align-items-center justify-content-center">
                        <a :href="baseUrl+data.item.path" target="_blank">
                            <feather-icon
                                v-if="!can('vhe_delete_document_contract_client_ee')"
                                :id="`record-row-${data.item.id}-see-icon`"
                                icon="EyeIcon"
                                size="16"
                                variant="warning"
                                class="cursor-pointer mr-1 text-blue"
                            />
                        </a>
                        <feather-icon
                            v-if="!can('vhe_delete_document_contract_client_ee')"
                            :id="`record-row-${data.item.id}-delete-icon`"
                            icon="TrashIcon"
                            size="16"
                            class="cursor-pointer text-red"
                            @click="deleteDocument(data.item.id, data.item.path)"
                        />
                    </div>
                </template>
            </b-table>
            <template>
                <div v-if="currentDocumentId>0">
                    <b-overlay
                        variant="white"
                        :show="showLoading"
                        spinner-variant="primary"
                        blur="0"
                        opacity=".75"
                        rounded="sm"
                    >
                        <vue-dropzone
                            id="dropzone"
                            ref="dropzone"
                            :options="dropzoneOptions"
                            :use-custom-slot="true"
                            @vdropzone-complete="complete"
                            @vdropzone-error="handleDropzoneError"
                        >
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">Arrastrar y soltar para subir archivo</h3>
                                <div class="subtitle">...o hacer clic para seleccionar un archivo de tu ordenador
                                </div>
                            </div>
                        </vue-dropzone>
                    </b-overlay>
                </div>
            </template>

            <b-button class="mt-3" variant="outline-danger" block @click="closeModal()">Cerrar</b-button>
        </b-modal>
    </div>
</template>

<script>
import {BTable,BFormRadio, BFormInput, BModal, BButton, BOverlay, BFormTextarea, BFormCheckbox, BFormGroup, BBadge} from 'bootstrap-vue'
import {baseUrl} from "@/constants/app"
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'
import authService from "@/services/auth/authService"
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import flatPickr from "vue-flatpickr-component"
import VueDropzone from "vue2-dropzone"
import helper from "@/resources/helpers/helpers"
import Swal from "sweetalert2"
import vSelect from "vue-select"
import {mapState} from "vuex"
import {mapFields} from "vuex-map-fields"
import {createPopper} from '@popperjs/core'

import {maintenancePeriods} from "@/constants/childrenDocuments"

export default {
    components: {
        BTable,
        BFormRadio,
        BFormInput,
        BModal,
        BButton,
        BOverlay,
        flatPickr,
        BFormTextarea,
        BFormCheckbox,
        BFormGroup,
        BBadge,
        vSelect,
        VueDropzone: VueDropzone,
    },
    props: {
        documentsStateData: {
            type: Array,
            required: true
        },
        documentsColumns: {
            type: Array,
            required: true
        },
        documentsRoute: {
            type: Array,
            required: true
        },
        context: {
            type: String,
            required: true
        },
        createPermission: {
            type: Boolean,
        },
        deletePermission: {
            type: Boolean,
        }
    },

    data() {
        return {
            baseUrl,
            currentDocumentId: null,
            selectedRow: null,
            placement: 'top',

            showModal: false,
            SpanishLocale,
            edit: false,
            showLoading: false,
            urlDocs: null,
            editedRow: null,
            columnsDocuments: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'name', label: 'Archivo', sortable: false},
            ],
            dropzoneOptions: {},

            maintenancePeriods
        }
    },
    computed: {
        ...mapState('providersVhe', []),
        ...mapState('childrenInstallationDocumentsVhe', []),
        ...mapFields({
            providers: 'providersVhe.providers',
            documentsTypes: 'documentsTypesVhe.document_types',
            incidencesTypes: 'incidencesTypesVhe.incidence_types',
            document_maintenance_active: 'childrenInstallationDocumentsVhe.document_maintenance_active',
        }),
    },
    mounted() {
        this.getAllMaintenanceTaskTypes()
        this.getAllProviders()
        this.getAllIncidenceTypes()
        this.$root.$refs.tabMaintenanceForm = this
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        withPopper(dropdownList, component, {width}) {
            dropdownList.style.width = width
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({state}) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })

            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
        isRowEditable(item) {
          if (!this.deletePermission) {
            return false
          }
          return item === this.editedRow || item === this.documentsStateData.editedRow
        },
        handleIconClick(item) {
          if (!this.editedRow && this.editedRow?.id !== item.id) {
            this.handleRowClick(item)
          } else {
            this.editRow(item)
          }
        },
        handleRowClick(item) {
          if (!this.isRowEditable(item) && !this.editedRow) {
            this.editedRow = item
          }
        },
        editRow(item) {
          this.updateRecord(this.editedRow || item)
          this.editedRow = null
        },
        getButtonVariant(item) {
            return this.isRowEditable(item) ? 'text-green' : 'info'
        },
        getButtonIcon(item) {
            return this.isRowEditable(item) ? 'CheckIcon' : 'EditIcon'
        },
        getButtonText(item) {
            return this.isRowEditable(item) ? 'Guardar' : 'Editar'
        },
        closeModal() {
            this.showModal = false
            this.$root.$refs.childrenInstallationForm.getChildInstallation()

        },
        seeDocumentsList(id) {
            this.currentDocumentId = id
            this.updateDropzoneOptions()
            this.$store.dispatch('childrenInstallationDocumentsVhe/getDocumentsList', {id: id, context: this.context})
            .then(response => {
                this.showLoading = false
                this.showModal = true
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        updateDropzoneOptions() {
            this.dropzoneOptions = {
                url: baseUrl + 'api/vhe/children-installation/documents/' + this.context + '/upload-documents/' + this.currentDocumentId,
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                autoProcessQueue: true,
                addRemoveLinks: true,
                headers: {"Authorization": 'Bearer ' + authService.accessToken()},
            }
        },
        complete: function (file) {
            this.showLoading = true
            this.seeDocumentsList(this.currentDocumentId)
            setTimeout(() => {
                this.$refs.dropzone.removeAllFiles()
            }, 2000)
        },
        handleDropzoneError(file, message, xhr) {
          message.errors.file.forEach(error =>
              helper.showToast(error, 'AlertOctagonIcon', 'danger')
          )
        },
        updateRecord(item) {
            item.context = this.context

            if (item.id) {
                this.$store.dispatch('childrenInstallationDocumentsVhe/updateRecordGeneralData', item)
                .then(() => {
                    this.showLoading = false
                    this.$root.$refs.childrenInstallationForm.getChildInstallation()

                    helper.showToast('Registro actualizado correctamente!', 'CheckIcon', 'success')
                })
                .catch(error => {
                    this.showLoading = false
                    helper.showToast('Error en editar al actualizar registro', 'AlertOctagonIcon', 'danger')
                })
            } else {
                this.$store.dispatch('childrenInstallationDocumentsVhe/createRecordGeneralData', item)
                .then(() => {
                    this.showLoading = false

                    this.$root.$refs.childrenInstallationForm.getChildInstallation()
                    helper.showToast('Registro creado correctamente!', 'CheckIcon', 'success')
                })
                .catch(error => {
                    this.showLoading = false
                    helper.showToast('Error en editar al crear registro', 'AlertOctagonIcon', 'danger')
                })
            }
        },
        deleteRecord(id, index) {
            if (id) {
                Swal.fire({
                    title: "Estás seguro que quieres borrar el registro?",
                    text: "Una vez borrado no se podrá recuperar!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "¡Sí, borralo!",
                    cancelButtonText: "Cancelar",
                }).then(result => {
                    if (result.value) {
                        this.showLoading = true
                        this.$store.dispatch('childrenInstallationDocumentsVhe/deleteRecord', {
                            id: id,
                            context: this.context
                        })
                        .then(response => {
                            this.showLoading = false
                            helper.showToast('Registro eliminado correctamente!', 'CheckIcon', 'success')
                            this.$root.$refs.childrenInstallationForm.getChildInstallation()
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                    }
                })
            } else {
                this.documentsStateData.splice(index, 1)
            }
        },
        deleteDocument(recordId, path) {
            if (recordId) {
                Swal.fire({
                    title: "Estás seguro que quieres borrar el archivo?",
                    text: "Una vez borrado no se podrá recuperar!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "¡Sí, borralo!",
                    cancelButtonText: "Cancelar",
                }).then(result => {
                    if (result.value) {
                        this.showLoading = true
                        this.$store.dispatch('childrenInstallationDocumentsVhe/deleteDocument', {
                            id: recordId,
                            path: path,
                            context: this.context
                        })
                        .then(response => {
                          this.showLoading = false
                          this.$root.$refs.childrenInstallationForm.getChildInstallation()
                          helper.showToast('Registro eliminado correctamente!', 'CheckIcon', 'success')
                          this.seeDocumentsList(this.currentDocumentId)
                        })
                        .catch(error => {
                            this.showLoading = false
                            console.log(error)
                        })
                    }
                })
            }
        },
        getAllMaintenanceTaskTypes() {
            this.showLoading = true

            this.$store.dispatch('maintenanceTaskTypesVhe/getAllMaintenanceTaskTypes')
            .then(response => {
                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        getAllProviders() {
            this.showLoading = true

            this.$store.dispatch('providersVhe/getAllProviders')
            .then(response => {
                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        getAllIncidenceTypes() {
            this.showLoading = true

            this.$store.dispatch('incidencesTypesVhe/getAllIncidenceTypes')
            .then(response => {
                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        setActiveMaintenance(item) {
            this.showLoading = true
            this.$store.dispatch('childrenInstallationDocumentsVhe/setActiveMaintenance', {data: item.id})
           
            if(item.inspection !== 'undefined' && item.inspection !== null) {

                this.setInspection(item.inspection)
            } else {
                const newRow = [{
                    effective_date: null,
                    made_by: null,
                    observations: null,
                    route: this.$store.state.childrenInstallationVhe.child_installation.master_installation.installation_code +"/"+ this.$store.state.childrenInstallationVhe.child_installation.vhe_code + "/MANTENIMIENTOSCORRECTIVOS/INSPECCIONES",
                    maintenance_id: this.document_maintenance_active
                }]

                this.$store.state.childrenInstallationDocumentsVhe.documents_maintenance_inspection = (newRow)
            }

            if(item.insitu !== 'undefined' && item.insitu !== null) {
                this.setInSitu(item.insitu)
            } else {
                const newRow = [{
                    effective_date: null,
                    made_by: null,
                    observations: null,
                    defects: 0,
                    route: this.$store.state.childrenInstallationVhe.child_installation.master_installation.installation_code +"/"+ this.$store.state.childrenInstallationVhe.child_installation.vhe_code + "/MANTENIMIENTOSCORRECTIVOS/ACAEInSitu",
                    maintenance_id: this.document_maintenance_active
                }]

                this.$store.state.childrenInstallationDocumentsVhe.documents_maintenance_insitu = (newRow)
            }
            if(item.invigilando !== 'undefined' && item.invigilando !== null) {
                this.setInvigilando(item.invigilando)
            } else {
                const newRow = [{
                    effective_date: null,
                    made_by: null,
                    observations: null,
                    defects: 0,
                    route: this.$store.state.childrenInstallationVhe.child_installation.master_installation.installation_code +"/"+ this.$store.state.childrenInstallationVhe.child_installation.vhe_code + "/MANTENIMIENTOSCORRECTIVOS/INVIGILANDO",
                    maintenance_id: this.document_maintenance_active
                }]

                this.$store.state.childrenInstallationDocumentsVhe.documents_maintenance_invigilando = (newRow)
            }
           
        },
        setInspection(inspection) {
            if(inspection){
                this.$store.dispatch('childrenInstallationDocumentsVhe/setInspectionByMaintenance', {data: inspection})
            }  
        },
        setInSitu(insitu) {
            if(insitu){
                this.$store.dispatch('childrenInstallationDocumentsVhe/setInSituByMaintenance', {data: insitu})
            }
        },
        setInvigilando(invigilando) {
            if(invigilando){
                this.$store.dispatch('childrenInstallationDocumentsVhe/setInvigilandoByMaintenance', {data: invigilando})
            }
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

[dir] .modal .modal-header .close {
    box-shadow: none;
    transform: unset;
    background: none;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>